// Function to format date from YYYYMMDD string
export const formatDate = (dateString: string): string => {
  // input is something like this "20240903"
  // Extract year, month, and day from the dateString
  const year = parseInt(dateString.substring(0, 4), 10);
  const month = parseInt(dateString.substring(4, 6), 10) - 1; // Months are 0-based
  const day = parseInt(dateString.substring(6, 8), 10);

  const date = new Date(year, month, day);

  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};
